/**
 * Settings required to generate child report comparing two results.
 *
 * @field data_sets_uuid ... Comma separated UUID of data sets to compare
 */
export interface ComparisonReportSettingsContract {
  data_set_uuids: string;
}
